<mat-form-field [subscriptSizing]="data.subscriptSizing ?? 'fixed'" color="accent">
  @if (data.label) {
    <mat-label>{{ data.label }}</mat-label>
  }

  <input
    #matInput="matInput"
    [control]="control"
    [data]="data"
    [formControl]="control"
    [placeholder]="data.placeholder || ''"
    [type]="data.type"
    matInput
    uiFormInputAttributes
    uiFormInputValidators
  >

  @if (data.prefixIcon && data.prefixIconStyle) {
    <button (click)="prefixClick.emit($event)" mat-icon-button matPrefix>
      <ui-icon [faName]="data.prefixIcon" [faStyle]="data.prefixIconStyle"></ui-icon>
    </button>
  }

  @if (control.enabled && !data.attributes?.readOnly && (control.value || matInput.errorState)) {
    <button
      (click)="$event.preventDefault();$event.stopPropagation();control.setValue('')"
      [color]="matInput.errorState ? 'warn' : undefined"
      mat-icon-button
      matSuffix
      type="button"
    >
      <ui-icon [faName]="control.valid ? 'circle-xmark' : 'circle-exclamation'" faStyle="light"></ui-icon>
    </button>
  }

  @if (data.suffixIcon && data.suffixIconStyle) {
    <button (click)="suffixClick.emit($event)" mat-icon-button matSuffix>
      <ui-icon [faName]="data.suffixIcon" [faStyle]="data.suffixIconStyle"></ui-icon>
    </button>
  }

  <mat-error [control]="control" [data]="data" uiFormError></mat-error>

  @if (data.hint) {
    <mat-hint [innerHtml]="data.hint"></mat-hint>
  }
</mat-form-field>

@if (data.description) {
  <ui-form-input-description [description]="data.description"></ui-form-input-description>
}
